import { useParams } from 'react-router-dom';
import useGetAdminService from '@/hooks/admin/services/useGetAdminService';
import StaticCrumb from '../StaticCrumb';
import type { ServiceCrumbProps } from './types';

const ServiceCrumb = ({ param, isCurrentPage }: ServiceCrumbProps) => {
    const params = useParams();
    const serviceId = params[param] || '';
    const { service } = useGetAdminService({ serviceId });

    return (
        <StaticCrumb
            label={service ? service.name : serviceId}
            href={`/admin/services/${serviceId}`}
            isCurrentPage={isCurrentPage}
        />
    );
};

export default ServiceCrumb;
